<template>
  <div
    class="w-full flex flex-col justify-center h-full fixed block top-0 left-0 bg-white opacity-1 z-50"
  >
    <div
      class="mt-8 font-semibold text-yellow-600 tracking-wider cursor-pointer nav-item"
      @click="close('#about')"
    >
      About
    </div>
    <div
      class="mt-8 font-semibold text-yellow-600 tracking-wider cursor-pointer nav-item"
      @click="close('#experience')"
    >
      Experience
    </div>
    <div
      class="mt-8 font-semibold text-yellow-600 tracking-wider cursor-pointer nav-item"
      @click="close('#projects')"
    >
      Projects
    </div>
    <div
      class="mt-8 font-semibold text-yellow-600 tracking-wider cursor-pointer nav-item"
      @click="close('#contact')"
    >
      Contact
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    close(id) {
      this.$scrollTo(id);
      this.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
.nav-item {
  &:hover {
    letter-spacing: 2px;
  }
}
</style>